// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__kk9Yn","Menu":"SiderContentC_Menu__hHr-h"};